export default "__VITE_ASSET__UToeqQ6k__"